import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AnyValidateFunction } from "ajv/dist/core";
import { AuthService } from '../../auth.service';

var misc: any = {
  sidebar_mini_active: true
};

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  iconSrc?: string;
  roles?: string[];
  collapse?: string;
  isCollapsed?: boolean;
  isCollapsing?: any;
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  type?: string;
  collapse?: string;
  children?: ChildrenItems2[];
  isCollapsed?: boolean;
}
export interface ChildrenItems2 {
  path?: string;
  title?: string;
  type?: string;
}
//Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard/admin",
    title: "Dashboard",
    type: "link",
    icontype: "",
    iconSrc: "assets/img/icons/common/dashboard-icon.svg",
    roles: ["admin"],
  },
  {
    path: "/dashboard/merchant",
    title: "Dashboard",
    type: "link",
    icontype: "",
    iconSrc: "assets/img/icons/common/dashboard-icon.svg",
    roles: ["merchant"],
  },
  {
    path: "/mid",
    title: "MID",
    type: "sub",
    icontype: "ni-credit-card text-orange",
    collapse: "mid",
    isCollapsed: true,
    children: [
      { path: "mid-list", title: "MID List", type: "link" },
    ],
    roles: ["admin", "merchant"],
  },
  {
    path: "/transactions",
    title: "Transactions",
    type: "sub",
    icontype: "ni-bullet-list-67 text-red",
    collapse: "transactions",
    isCollapsed: true,
    children: [
      { path: "transaction-list", title: "Transactions List", type: "link" },
      { path: "form", title: "New Transaction", type: "link" },
    ],
    roles: ["admin", "merchant"],
  },
  {
    path: "/accounts",
    title: "Accounts",
    type: "link",
    icontype: "ni-user-run text-red",
    roles: ["admin"],
  },
  {
    path: "/audit-logs",
    title: "Logs",
    type: "link",
    icontype: "",
    iconSrc: "assets/img/icons/common/audit-logs-icon.svg",
    roles: ["admin"],
  },
];

@Component({ standalone: false,
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit {
  public menuItems!: any[];
  public isCollapsed = true;
  userDetails: any;
  userRole:any;
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.userDetails = this.authService.getSession();
    this.userRole=this.authService.getRole();
    this.menuItems = ROUTES.filter(menuItem =>
      !menuItem.roles || menuItem.roles.includes(this.userRole)
    );
    this.router.events.subscribe(event => {
      this.isCollapsed = true;
    });

  }
  closeSidebarMobile() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove("g-sidenav-pinned");
    body.classList.remove("g-sidenav-show");
    body.classList.add("g-sidenav-hidden");
    window.dispatchEvent(new CustomEvent("sidenav-closed"));
  }
  onMouseEnterSidenav() {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  }
  onMouseLeaveSidenav() {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  }
  minimizeSidebar() {
    const sidenavToggler = document.getElementsByClassName(
      "sidenav-toggler"
    )[0];
    const body = document.getElementsByTagName("body")[0];
    if (body.classList.contains("g-sidenav-pinned")) {
      misc.sidebar_mini_active = true;
    } else {
      misc.sidebar_mini_active = false;
    }
    if (misc.sidebar_mini_active === true) {
      body.classList.remove("g-sidenav-pinned");
      body.classList.add("g-sidenav-hidden");
      sidenavToggler.classList.remove("active");
      misc.sidebar_mini_active = false;
    } else {
      body.classList.add("g-sidenav-pinned");
      body.classList.remove("g-sidenav-hidden");
      sidenavToggler.classList.add("active");
      misc.sidebar_mini_active = true;
    }
  }
}
